<template>
  <loading-panel v-if="!$store.state.rooms" />
  <div v-else id="app">
    <router-view />
  </div>
</template>

<script>
import LoadingPanel from './components/LoadingPanel.vue'
import { DashundClient } from './store/dashund-client'

import { ROOMS_API_URL } from './config'

export default {
  components: { LoadingPanel },
  data() {
    return { api: null }
  },
  mounted() {
    this.api = new DashundClient(ROOMS_API_URL)

    this.api.subscribe('rooms', res => {
      if (res.status === 200) {
        this.$store.commit('setRooms', res.data)
      } else {
        this.$store.commit('setRooms', null)
      }
    })

    this.$timer.setup()
  },
  destroyed() {
    this.api.close()
    this.api = null

    this.$timer.teardown()
  }
}
</script>

<style lang="scss">
@import '@/scss/theme.scss';
</style>
